import stellarLogo from '../assets/chains/stellar.png';
import ethereumLogo from '../assets/chains/ethereum.png';
import polygonLogo from '../assets/chains/polygon.png';
import baseLogo from '../assets/chains/base.png';
import hyperliquidLogo from '../assets/chains/hyperliquid.png';

// Plans and USDC payment addresses for the Billing page (demo). The addresses are demo addresses,
// the same for every account, until the backend generates one per account.

export interface Plan {
  id: string;
  name: string;
  /** USDC per period; 0 for the trial. */
  price: number;
  period: 'month' | 'year';
  description: string;
}

export const PLANS: Plan[] = [
  { id: 'trial', name: 'Free Trial', price: 0, period: 'month', description: '1 month, free' },
  { id: 'light-monthly', name: 'Monthly Light', price: 300, period: 'month', description: '300 USDC / month' },
  { id: 'pro-monthly', name: 'Monthly Pro', price: 949, period: 'month', description: '949 USDC / month' },
  { id: 'pro-annual', name: 'Annually Pro', price: 9900, period: 'year', description: '9,900 USDC / year' },
];

export const DEFAULT_PLAN_ID = 'trial';

/** Demo receiving addresses: one for every EVM chain, one for Stellar. */
export const DEMO_EVM_ADDRESS = '0xdF769739e1171A1c39c3461D423acC27A8060aa1';
export const DEMO_STELLAR_ADDRESS = 'GAN7BT4ETNGW3WVNYNPNWG7KZTTSA7LFQ2ZIEZHESZY7L6IH4K6VSKQW';

export interface PaymentChain {
  id: string;
  name: string;
  kind: 'evm' | 'stellar';
  /** The chain's logo (the ones of the insurer deck; some are light, for a dark background). */
  logo: string;
  address: string;
  /** The official USDC token id on that chain (Circle's native USDC). */
  usdc: string;
  /** For Stellar: the classic asset, whose Stellar Asset Contract is `usdc`. */
  usdcAsset?: { code: string; issuer: string };
  decimals: number;
  rpcUrl: string;
  explorer: (address: string) => string;
}

export const PAYMENT_CHAINS: PaymentChain[] = [
  {
    id: 'stellar',
    logo: stellarLogo,
    name: 'Stellar',
    kind: 'stellar',
    address: DEMO_STELLAR_ADDRESS,
    usdc: 'CCW67TSZV3SSS2HXMBQ5JFGCKJNXKZM7UQUWUZPUTHXSTZLEO7SJMI75',
    usdcAsset: { code: 'USDC', issuer: 'GA5ZSEJYB37JRC5AVCIA5MOP4RHTM335X2KGX3IHOJAPP5RE34K4KZVN' },
    decimals: 7,
    rpcUrl: 'https://horizon.stellar.org',
    explorer: (a) => `https://stellar.expert/explorer/public/account/${a}`,
  },
  {
    id: 'ethereum',
    logo: ethereumLogo,
    name: 'Ethereum',
    kind: 'evm',
    address: DEMO_EVM_ADDRESS,
    usdc: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    decimals: 6,
    rpcUrl: 'https://ethereum-rpc.publicnode.com',
    explorer: (a) => `https://etherscan.io/address/${a}`,
  },
  {
    id: 'polygon',
    logo: polygonLogo,
    name: 'Polygon',
    kind: 'evm',
    address: DEMO_EVM_ADDRESS,
    usdc: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    decimals: 6,
    rpcUrl: 'https://polygon-bor-rpc.publicnode.com',
    explorer: (a) => `https://polygonscan.com/address/${a}`,
  },
  {
    id: 'base',
    logo: baseLogo,
    name: 'Base',
    kind: 'evm',
    address: DEMO_EVM_ADDRESS,
    usdc: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    decimals: 6,
    rpcUrl: 'https://mainnet.base.org',
    explorer: (a) => `https://basescan.org/address/${a}`,
  },
  {
    id: 'hyperliquid',
    logo: hyperliquidLogo,
    name: 'Hyperliquid (HyperEVM)',
    kind: 'evm',
    address: DEMO_EVM_ADDRESS,
    usdc: '0xb88339CB7199b77E23DB6E890353E22632Ba630f',
    decimals: 6,
    rpcUrl: 'https://rpc.hyperliquid.xyz/evm',
    explorer: (a) => `https://hyperevmscan.io/address/${a}`,
  },
];
